<template>
	<div class="rate-wrapper" :class="{active: shouldOpenScorePopup}" @click="onClickRate">
		<fieldset class="rate" inert>
			<input v-model="value" type="radio" value="5" class="rate_item">
			<label title="5"></label>
			<input v-model="value" type="radio" value="4.5" class="rate_item">
			<label title="4.5" class=" half "></label>
			<input v-model="value" type="radio" value="4" class="rate_item">
			<label title="4"></label>
			<input v-model="value" type="radio" value="3.5" class="rate_item">
			<label title="3.5" class=" half "></label>
			<input v-model="value" type="radio" value="3" class="rate_item">
			<label title="3"></label>
			<input v-model="value" type="radio" value="2.5" class="rate_item">
			<label title="2.5" class=" half "></label>
			<input v-model="value" type="radio" value="2" class="rate_item">
			<label title="2"></label>
			<input v-model="value" type="radio" value="1.5" class="rate_item">
			<label title="1.5" class=" half "></label>
			<input v-model="value" type="radio" value="1" class="rate_item">
			<label title="1"></label>
			<input v-model="value" type="radio" value="0.5" class="rate_item">
			<label title="0.5" class=" half "></label>
		</fieldset>
		<div v-if="showCount && votesCount" class="rate_votes">
			{{ votesCount }} {{ getNoun(votesCount, 'оценка', 'оценки', 'оценок') }}
		</div>
	</div>
</template>

<script>
import { getNoun } from '../../utils/getNoun.js';
import { mapActions, mapMutations } from 'vuex';
export default {
	name: 'Rating',
	props: {
		rating: {
			type: Number,
			required: true,
		},
		votesCount: {
			type: Number,
			required: true,
		},
		showCount: {
			type: Boolean,
			required: true,
		},
		shouldOpenScorePopup: {
			type: Boolean,
			default: false,
		},
		productId: {
			type: [Number, String],
			default: '',
		}
	},
	setup() {
		return {
			getNoun
		}
	},
	data() {
		return {
			value: this.rating,
		}
	},
	methods: {
		...mapMutations({
			setReviewProductId: 'setReviewProductId',
		}),
		...mapActions({
			requestReviewPermission: 'requestReviewPermission',
		}),
		async onClickRate() {
			if (!this.shouldOpenScorePopup || !this.productId) return;

			this.setReviewProductId(this.productId);
			const isReviewAllowed = await this.requestReviewPermission(this.productId);

			if (isReviewAllowed) {
				window.openCompactModal('add-score-popup');
			}
		}
	}
}
</script>
